export const FETCH_STUDENT_LOCATION_PENDING = 'FETCH_STUDENT_LOCATION_PENDING'
export const FETCH_STUDENT_LOCATION_FULFILLED = 'FETCH_STUDENT_LOCATION_FULFILLED'
export const FETCH_STUDENT_LOCATION_REJECTED = 'FETCH_STUDENT_LOCATION_REJECTED'

export const UPDATE_STUDENT_LOCATION_PENDING = 'UPDATE_STUDENT_LOCATION_PENDING'
export const UPDATE_STUDENT_LOCATION_FULFILLED = 'UPDATE_STUDENT_LOCATION_FULFILLED'
export const UPDATE_STUDENT_LOCATION_REJECTED = 'UPDATE_STUDENT_LOCATION_REJECTED'

export const RESET_STUDENT_LOCATION = 'RESET_STUDENT_LOCATION'

export const UPDATE_STUDENT_LOCATION_FORM = 'updateStudentLocationForm'
export const UPDATE_STUDENT_LOCATION_FIELDS = {
  studentId: { name: 'studentId', required: true },
  province: { name: 'provinceCode', required: true },
}
